import {Injectable, inject, signal} from '@angular/core';
import {ExpertWalletService} from '@services/expert-wallet.service';

@Injectable({
  providedIn: 'root',
})
export class ExpertWalletAccessState {
  private readonly expertWalletService = inject(ExpertWalletService);

  private readonly hasAccessSignal = signal(false);
  private loaded = false;

  hasAccess = this.hasAccessSignal.asReadonly();

  ensureLoaded(): void {
    if (this.loaded) {
      return;
    }
    this.loaded = true;
    this.expertWalletService.checkAccess().subscribe({
      next: (status) => this.hasAccessSignal.set(!!status.hasAccess),
      error: () => this.hasAccessSignal.set(false),
    });
  }

  refresh(): void {
    this.loaded = false;
    this.ensureLoaded();
  }
}
